import { t } from "@lingui/macro";
import React from "react";

import {
  InfoIcon,
  PlaceIcon,
} from "@whoosh/design-system/src/components/icons_v2/general";
import {
  Box,
  HStack,
  Text,
  VStack,
} from "@whoosh/design-system/src/components/primitive";
import { WhooshThemeColors } from "@whoosh/design-system/src/theme/restyle/theme";

type InfoRestrictionBarProps = {
  color: WhooshThemeColors;
  title: string;
  courseNames: string;
  allDay?: boolean;
  startAt: string;
  endAt: string;
  memberMessage?: string | null;
};

export const InfoRestrictionBar = ({
  color,
  title,
  courseNames,
  allDay,
  startAt,
  endAt,
  memberMessage,
}: InfoRestrictionBarProps) => {
  const getCourseText = () => {
    const splitCourseInfo = courseNames.split(", ");
    const courseCount = splitCourseInfo.length;
    return courseNames === "All Courses"
      ? t`All Courses`
      : splitCourseInfo.length > 1
      ? `${courseCount} ${t`Courses`}`
      : splitCourseInfo[0];
  };

  const getTimeValue = () => {
    if (allDay) return t`All Day`;
    if (startAt && endAt) return `${startAt} - ${endAt}`;
    if (startAt) return `${t`Starts at`} ${startAt}`;
    if (endAt) return `${t`Ends at`} ${endAt}`;
    return "";
  };

  return (
    <Box
      backgroundColor="surface-primary"
      my={2}
      px={1}
      py={1}
      style={{ borderRadius: 12 }}
      testID={`info-restriction-bar-${title
        .toLowerCase()
        .replace(/[^a-z0-9]+/gi, "-")}`}
    >
      <HStack justifyContent="space-between" alignItems="center">
        <HStack alignItems="center" gap={4}>
          <Box
            width={40}
            height={40}
            backgroundColor={color}
            borderRadius={"2"}
            justifyContent="center"
            alignItems="center"
          >
            <InfoIcon color="black" />
          </Box>
          <VStack>
            {title ? <Text variant="mainSmallSemiBold">{title}</Text> : null}
            {!!getTimeValue().length ? (
              <Text variant="mainSmallSemiBold" color="text-secondary">
                {getTimeValue()}
              </Text>
            ) : null}
          </VStack>
        </HStack>
        <HStack alignItems="center" gap={1} mr={3}>
          <Text variant="mainTiny">{getCourseText()}</Text>
          <PlaceIcon color="black" />
        </HStack>
      </HStack>
      {memberMessage ? (
        <Text variant="mainBaseMedium" mt={2}>
          {memberMessage}
        </Text>
      ) : null}
    </Box>
  );
};
